export const MAX_WORDS_COUNT = 20;
export const MAX_PAGE_INDEX = 30;
export const WRONG_ANSWERS_COUNT = 3;
